<!-- 商品发布 - 库存价格 -->
<template>
	<a-spin :spinning="formLoading">
		<a-form ref="formRef" :disabled="isDetail" :model="formData" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
			<a-form-item label="">
				<a-row :gutter="[16, 16]">
					<a-col :span="3">
						<a-button class="mb-10px mr-15px" @click="addPriceItem">添加价格</a-button>
					</a-col>
					<a-col :span="3">
						
					</a-col>
				</a-row>
			</a-form-item>
			<template >
				<a-form-item v-if="!isDetail" label="批量设置">
					<a-row :gutter="[16, 16]">
						<a-col :span="3">
							<imageUpload
								ref="batchImageUpload"
								:value="batchPrice.picUrl"
								:file-list="[{ uid: '1', name: 'image.png', status: 'done', url: batchPrice.picUrl || '' }]"
								:remove="() => handleBatchRemove()"
								:isShowTip="false"
								:limit="1"
								@input="(val) => batchPrice.picUrl = val"
							/>
						</a-col>
						<a-col :span="3">
							<div class="text-sm text-gray-600 mb-2">价格名称</div>
							<a-input v-model="batchPrice.priceName" placeholder="价格名称" />
						</a-col>
						<a-col :span="3">
							<div class="text-sm text-gray-600 mb-2">商品价格</div>
							<a-input-number v-model="batchPrice.price" :step="0.01" placeholder="商品价格" style="width: 100%" />
						</a-col>
						<a-col :span="3">
							<div class="text-sm text-gray-600 mb-2">市场价</div>
							<a-input-number v-model="batchPrice.marketPrice" :step="0.01" placeholder="市场价" style="width: 100%" />
						</a-col>
						<a-col :span="3">
							<div class="text-sm text-gray-600 mb-2">成本价</div>
							<a-input-number v-model="batchPrice.costPrice" :step="0.01" placeholder="成本价" style="width: 100%" />
						</a-col>
						<a-col :span="3">
							<div class="text-sm text-gray-600 mb-2">库存</div>
							<a-input-number v-model="batchPrice.stock" :step="1" placeholder="库存" style="width: 100%" />
						</a-col>
						<a-col :span="3">
							<div class="text-sm text-gray-600 mb-2">排序</div>
							<a-input-number v-model="batchPrice.sort" :step="1" placeholder="排序" style="width: 100%" />
						</a-col>
						<a-col :span="3">
							<div class="text-sm text-gray-600 mb-2">操作</div>
							<a-button type="primary" @click="batchSetPrice">批量设置</a-button>
						</a-col>
						
					</a-row>
				</a-form-item>
				<a-form-item label="价格列表">
					<div v-if="formData.priceList.length === 0" class="text-center py-10">
						暂无价格数据，请点击"添加价格"按钮
					</div>
					<div v-else>
						<div v-for="(item, index) in formData.priceList" :key="index" class="mb-10px p-10px bg-gray-50 border rounded">
							<a-row :gutter="[16, 16]">
								<a-col :span="3">
									<imageUpload
										ref="imageUpload"
										:value="item.picUrl"
										:file-list="[{ uid: '1', name: 'image.png', status: 'done', url: item.picUrl || '' }]"
										:isShowTip="false"
										:limit="1"
										@input="(val) => item.picUrl = val"
									/>
								</a-col>
								<a-col :span="3">
									<div class="text-sm text-gray-600 mb-2">价格名称</div>
									<a-input v-model="item.priceName" placeholder="请输入价格名称" />
								</a-col>
								<a-col :span="3">
									<div class="text-sm text-gray-600 mb-2">商品价格</div>
									<a-input-number v-model="item.price" :min="0.01" :step="0.01" placeholder="请输入商品价格" style="width: 100%" />
								</a-col>
								<a-col :span="3">
									<div class="text-sm text-gray-600 mb-2">市场价</div>
									<a-input-number v-model="item.marketPrice" :min="0.01" :step="0.01" placeholder="请输入市场价" style="width: 100%" />
								</a-col>
								<a-col :span="3">
									<div class="text-sm text-gray-600 mb-2">成本价</div>
									<a-input-number v-model="item.costPrice" :min="0" :step="0.01" placeholder="请输入成本价" style="width: 100%" />
								</a-col>
								<a-col :span="3">
									<div class="text-sm text-gray-600 mb-2">库存</div>
									<a-input-number v-model="item.stock" :min="0" :step="1" placeholder="请输入库存" style="width: 100%" />
								</a-col>
									<a-col :span="3">
									<div class="text-sm text-gray-600 mb-2">排序</div>
									<a-input-number v-model="item.sort" :min="0" :step="1" placeholder="请输入排序" style="width: 100%" />
								</a-col>
								<a-col :span="3">
									<div class="text-sm text-gray-600 mb-2">操作</div>
									<a-button v-if="!isDetail" size="small"  danger type="danger" @click="deletePriceItem(index)">删除</a-button>
								</a-col>

							</a-row>
							<a-row class="mt-10px" :gutter="[16, 16]">
								
							</a-row>
						</div>
					</div>
				</a-form-item>
			</template>
		</a-form>
	</a-spin>
</template>
<script>
import { copyValueToTarget } from '@/utils'
import imageUpload from '@/components/ImageUpload'
export default {
	name: 'ProductSpuSkuForm',
	props: {
		propFormData: {
			type: Object,
			default: () => {}
		},
		isDetail: {
			type: Boolean,
			default: false // 是否作为详情组件
		}
	},
	components: {
		imageUpload
	},
	data() {
		return {
			formLoading: false,
			attributesAddFormRef: null, // 添加商品属性表单
			formRef: null, // 表单 Ref
			formData: {
				priceList: [],
			},
			rules: {
				specType: [{ required: true, message: '请选择商品规格', trigger: 'change' }]
			},
			// price 相关属性校验规则
			ruleConfig: [
				{
					name: 'stock',
					rule: (arg) => arg >= 0,
					message: '商品库存必须大于等于 1 ！！！'
				},
				{
					name: 'price',
					rule: (arg) => arg >= 0.01,
					message: '商品销售价格必须大于等于 0.01 元！！！'
				},
				{
					name: 'marketPrice',
					rule: (arg) => arg >= 0.01,
					message: '商品市场价格必须大于等于 0.01 元！！！'
				},
				{
					name: 'costPrice',
					rule: (arg) => arg >= 0.01,
					message: '商品成本价格必须大于等于 0.00 元！！！'
				}
			],
			batchPrice: {
				priceName: '',
				price: 0,
				marketPrice: 0,
				costPrice: 0,
				picUrl: '',
				stock: 0,
				sort: 0,
			}
		}
	},
	watch: {
		propFormData: {
			handler: function(data) {
				if (!data) {
					return
				}
				copyValueToTarget(this.formData, data)
			},
			immediate: true
		}
	},
	methods: {
			/** 表单校验 */
			async validate() {
				try {
					// 自定义校验规则
					// 1. 价格列表不能为空
					if (!this.formData.priceList || this.formData.priceList.length === 0) {
						this.$message.error('价格列表不能为空，请至少添加一个价格项')
						throw new Error('价格列表不能为空')
					}
					
					// 2. 为价格列表内每条数据的字段添加非空校验和大于0校验
					for (let i = 0; i < this.formData.priceList.length; i++) {
						const item = this.formData.priceList[i]
						const index = i + 1
						// 非空校验
						if (!item.priceName) {
							this.$message.error(`第${index}个价格项的价格名称不能为空`)
							throw new Error(`第${index}个价格项的价格名称不能为空`)
						}
						if (!item.price) {
							this.$message.error(`第${index}个价格项的商品价格不能为空`)
							throw new Error(`第${index}个价格项的商品价格不能为空`)
						}
						if (!item.marketPrice) {
							this.$message.error(`第${index}个价格项的市场价不能为空`)
							throw new Error(`第${index}个价格项的市场价不能为空`)
						}
						if (!item.costPrice) {
							this.$message.error(`第${index}个价格项的成本价不能为空`)
							throw new Error(`第${index}个价格项的成本价不能为空`)
						}
						if (!item.stock) {
							this.$message.error(`第${index}个价格项的库存不能为空`)
							throw new Error(`第${index}个价格项的库存不能为空`)
						}
						
						// 大于0校验（除picUrl外）
						if (item.price <= 0) {
							this.$message.error(`第${index}个价格项的商品价格必须大于0`)
							throw new Error(`第${index}个价格项的商品价格必须大于0`)
						}
						if (item.marketPrice <= 0) {
							this.$message.error(`第${index}个价格项的市场价必须大于0`)
							throw new Error(`第${index}个价格项的市场价必须大于0`)
						}
						if (item.costPrice < 0) {
							this.$message.error(`第${index}个价格项的成本价不能小于0`)
							throw new Error(`第${index}个价格项的成本价不能小于0`)
						}
						if (item.stock < 0) {
							this.$message.error(`第${index}个价格项的库存不能小于0`)
							throw new Error(`第${index}个价格项的库存不能小于0`)
						}
	
					}
					
					// 校验通过更新数据
					Object.assign(this.propFormData, this.formData)
				} catch (e) {
					// this.$message.error('【库存价格】不完善，请填写相关信息')
					this.$emit('update:activeKey', 'price')
					throw e // 目的截断之后的校验
				}
			},
			/** 选择规格 */
			onChangeSpec() {
		
				// 重置priceList列表
				this.formData.priceList = [
					{
						priceName: '',
						price: 0,
						marketPrice: 0,
						costPrice: 0,
						barCode: '',
						picUrl: '',
						stock: 0,
						sort: 0
		
					}
				]
			},
			/** 添加价格项 */
			addPriceItem() {
				this.formData.priceList.push({
					priceName: '',
					price: 0,
					marketPrice: 0,
					costPrice: 0,
					barCode: '',
					picUrl: '',
					stock: 0,
					sort: 0
		
				})
			},
			/** 批量设置价格 */
			batchSetPrice() {
				this.$confirm({
					title: '提示',
					content: '确认批量设置当前所有价格项？',
					onOk: () => {
						this.setPrice()
					},
					onCancel() {

					},
				})
						
				
			},
			setPrice(){
				const { priceName, price, marketPrice, costPrice, stock, picUrl, sort } = this.batchPrice
				let index = 0
				this.formData.priceList.forEach(item => {
					// 只在批量设置有值时才同步
					index++
					if (priceName) item.priceName = priceName + index
					if (price !== 0) item.price = price
					if (marketPrice !== 0) item.marketPrice = marketPrice
					if (costPrice !== 0) item.costPrice = costPrice
					if (stock !== 0) item.stock = stock
					if (picUrl) item.picUrl = picUrl
					if (sort !== 0) item.sort = sort + index - 1
				})
				this.$message.success('批量设置成功')
			},
			/** 删除价格项 */
			deletePriceItem(index) {
				this.formData.priceList.splice(index, 1)
			},
		}
}
</script>
<style scoped lang="less">
// .qa-modal .ant-form{
//   overflow-y:auto;
// }
.tab-container .tab-pane{
  height: calc(100vh - 200px);
  overflow-y: hidden;
}

// 价格列表样式优化
.mb-10px {
  margin-bottom: 10px;
}

.p-10px {
  padding: 10px;
}

.bg-gray-50 {
  background-color: #f5f5f5;
}

.border {
  border: 1px solid #e8e8e8;
}

.rounded {
  border-radius: 4px;
}

// 标签样式统一
.text-sm {
  font-size: 12px;
  font-weight: 500;
  color: #666;
}

.mb-2 {
  margin-bottom: 5px;
}

// 输入框样式优化
:deep(.ant-input),
:deep(.ant-input-number) {
  border-radius: 4px;
}

// 按钮样式优化
:deep(.ant-btn-dangerous) {
  color: #ff4d4f;
}

// 图片上传组件样式
:deep(.ant-upload-list-picture-card-container) {
  width: 80px;
  height: 80px;
}
.close{
	position: absolute;
	top: -10px;
	right: -10px;
}
</style>
